export default __webpack_public_path__ + "b5a74e426986e0a6251529bac6a8faf1.png";